import { render, staticRenderFns } from "./accountCenter.vue?vue&type=template&id=53e5cfea&"
import script from "./accountCenter.vue?vue&type=script&lang=js&"
export * from "./accountCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports